(function (ws) {
    'use strict';
    ws.views.changePassword = ws.views.form.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_EVENT_ACTION: 'change_password',

        events: _.extend({}, ws.views.form.prototype.events, {
            'change input': 'resetField'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);
            this.$form = this.$('#profileForm');
            this.$globalError = this.$('.error-message');
            this.$newPassword = this.$('input[name="newPassword"]');
            this.$confirmPassword = this.$('input[name="checkNewPassword"]');
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.$globalError.html('');
            this.checkPassword();
        },

        /**
         * Hide BE errors when re-submitting form
         * @param {Object} ev
         */
        checkRequired: function(ev) {
            this.$('.help-inline').hide();
            ws.views.form.prototype.checkRequired.call(this, ev);
        },

        /**
         * check the password length to 8 characters and match the new password and confirm password.
         */
        checkPassword: function () {
            if (this.$newPassword.val() !== this.$confirmPassword.val()) {
                this.error = true;
                this.$newPassword.addClass(this.errorClass);
                this.$confirmPassword.addClass(this.errorClass);
                if (!this.$confirmPassword.nextAll(this.errorMsg).is(':visible')) {
                    this.$confirmPassword.nextAll(this.customErrorMsg).show();
                }
            } else if (this.$newPassword.val().length < 8) {
                this.error = true;
                this.$newPassword.addClass(this.errorClass);
                if (!this.$newPassword.nextAll(this.errorMsg).is(':visible')) {
                    this.$newPassword.nextAll(this.customErrorMsg).show();
                }
            }
        },

        /**
         * Reset field with error message
         * @param {Object} e
         */
        resetField: function (e) {
            var $el = $(e.target);
            $el.removeClass(this.errorClass);
            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
            $el.parents('.controls').next('.help-inline').hide();
        },

        /**
         * overrides submitForm to log GTM event
         */
        submitForm: function() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            dataLayerAA.event = {};
            dataLayerAA.event.action = 'change password';
            _satellite.track('event:user:user:preference');
            ws.views.form.prototype.submitForm.call(this);
        }
    });
})(westcon);
